var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C3.125 10 2 11.125 2 12.5C2 13.875 3.125 15 4.5 15C5.875 15 7 13.875 7 12.5C7 11.125 5.875 10 4.5 10ZM19.5 10C18.125 10 17 11.125 17 12.5C17 13.875 18.125 15 19.5 15C20.875 15 22 13.875 22 12.5C22 11.125 20.875 10 19.5 10ZM12 10C10.625 10 9.5 11.125 9.5 12.5C9.5 13.875 10.625 15 12 15C13.375 15 14.5 13.875 14.5 12.5C14.5 11.125 13.375 10 12 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal);
export default __webpack_public_path__ + "static/media/dots-horizontal.92c03ff393892e3791725ee3c13037ff.svg";
export { ForwardRef as ReactComponent };